import { lazyLoad } from 'utils/loadable';

export const CandidateEngagementInquiriesLoadable = lazyLoad(
  () => import('./CandidateEngagementInquiries'),
  module => module.CandidateEngagementInquiries,
);
